import Button from "@common/buttons/button"
import PopoverMenuStyled from "@common/popoverMenuStyled"
import Svg from "@common/svg"
import Tooltip from "@common/tooltip/tooltip"
import { isNullOrEmpty } from "@common/lib/util"
import { ActionMenuProps, Actions, Option } from "@common/types"

export default function ActionMenu({
  actions = [],
  showIconMenu = true,
  showPopoverMenu = true,
  onActionClick,
  popoverIcon = "dots-vertical",
  showIconMenuOnHover = false,
  strategy,
}: ActionMenuProps) {
  // Check if actions are null or empty and return null if so
  if (isNullOrEmpty(actions)) return null

  const handleActionClick = (option: Option) => {
    if (onActionClick) onActionClick(option)
  }

  const renderRowActionIcons = (actions: Actions) => {
    // If icon menu is not to be shown, return an empty fragment
    if (!showIconMenu) return <></>

    return (
      <div className="flex justify-start items-center">
        {actions.map((action, i) => {
          // Check if the icon should be displayed outside
          if (!action.isIconOutside) return null

          return (
            <div
              className={showIconMenuOnHover ? "invisible group-hover:visible" : ""}
              key={i}
            >
              <Button
                disabled={action?.disabled}
                variant={"minimal"}
                size={"icon"}
                onClick={(e) => {
                  e.stopPropagation()
                  !action?.disabled && handleActionClick(action)
                }}
              >
                <Tooltip isInteractive={false}>
                  <Tooltip.Trigger>
                    {typeof action?.icon === "string" ? (
                      <Svg classes="w-4 h-4 text-secondary" name={action.icon} />
                    ) : (
                      action.icon
                    )}
                  </Tooltip.Trigger>
                  <Tooltip.Content>{action.display}</Tooltip.Content>
                </Tooltip>
              </Button>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className="flex items-center group">
      {renderRowActionIcons(actions)}
      {showPopoverMenu && (
        <PopoverMenuStyled
          options={actions}
          onSelect={handleActionClick}
          position="bottom-end"
          strategy={strategy}
        >
          <Button variant={"minimal"} size={"icon"}>
            <Svg name={popoverIcon} classes="h-4 w-4" />
          </Button>
        </PopoverMenuStyled>
      )}
    </div>
  )
}
